import { Text } from "../../../component-library";
import React from "react";
import { SUPPORT_NUMBER, SUPPORT_NUMBER_HREF } from "../../../constants/aptihealth";

export const InactiveModal = (props) => {
  const _telClick = () => {
    window.open(SUPPORT_NUMBER_HREF);
  };
  const _emailClick = () => {
    window.open("mailto:support@aptihealth.com");
  };

  return (
    <div className="text-align-center mb-5 mx-5">
      <p className={"mb-3"}>
        <Text type="heading-1">Your Account is Inactive</Text>
      </p>
      <p className={"pb-2"}>
        <Text type="paragraph" color="grey">
          We're happy to see you! But your account is currently inactive. Please email us at{" "}
        </Text>
        <Text className="patient-contact-link" type="paragraph" onClick={_emailClick}>
          support@aptihealth.com
        </Text>
        <Text type="paragraph" color="grey">
          {" "}
          or call us at{" "}
        </Text>
        <Text className="patient-contact-link" type="paragraph" onClick={_telClick}>
          {SUPPORT_NUMBER}
        </Text>
        <Text type="paragraph" color="grey">
          {" "}
          to begin receiving care again.
        </Text>
      </p>
      <p>
        <Text type="paragraph" color="grey">
          In the meantime you will not be able to schedule new sessions or message your care team.
        </Text>
      </p>
    </div>
  );
};
